module.exports = __webpack_public_path__ + "static/media/ssai_google_dfp.ec0da5e4.svg";